document.addEventListener('DOMContentLoaded', function () {
  var productHandle = window.meta && window.meta.product && window.meta.product.handle;
  if (!productHandle) return;

  // Busca dados completos via API
  fetch('/products/' + productHandle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      var variants = product.variants;

      function updateSizeAvailability() {
        var colorInput = document.querySelector('input.variant-swatch__radio[name="option1"]:checked');
        if (!colorInput) return;
        var selectedColor = colorInput.value;

        var sizeInputs = document.querySelectorAll('input.block-swatch__radio[data-option-position="2"]');

        sizeInputs.forEach(function (input) {
          var sizeValue = input.value;
          var label = document.querySelector('label.block-swatch__item[for="' + input.id + '"]');

          var available = variants.some(function (v) {
            return v.option1 === selectedColor && v.option2 === sizeValue && v.available;
          });

          if (label) {
            if (!available) {
              label.classList.add('variant-option--unavailable');
            } else {
              label.classList.remove('variant-option--unavailable');
            }
          }
        });
      }

      document.querySelectorAll('input.variant-swatch__radio[name="option1"]').forEach(function (el) {
        el.addEventListener('change', updateSizeAvailability);
      });

      updateSizeAvailability();
    });
});
